import { AngularEnvironment } from "./angular-environment";

console.info("Actual environment: content");

export const environment:AngularEnvironment = {
  production: false,
  defaultServerEnvironmentType: "content"
};